<script setup lang="ts">
import StrikeThroughLine from "~/templates/partials/header/StrikeThroughLine.vue";
import type { PropertyGroupOption } from "@shopware-pwa/types";

export interface ColorOptionCircleButtonProps {
  isOptionNotAvailable?: boolean;
  isOptionSelected?: boolean;
  option?: PropertyGroupOption;
}

defineProps<ColorOptionCircleButtonProps>();
</script>

<template>
  <button
    data-testid="product-variant"
    :aria-label="`color-${option?.name ?? 'button'}`"
    class="flex-0 flex h-11 w-11 items-center justify-center overflow-hidden focus:rounded-full"
  >
    <span
      class="flex-0 relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-full border-2"
      :class="[isOptionSelected ? 'border-dark-blue' : 'border-light-grey']"
    >
      <span
        :id="`${option?.id}-choice-label`"
        class="relative h-7 w-7 rounded-full border border-gray-400"
        :style="{ backgroundColor: option?.colorHexCode ?? '#000' }"
        data-testid="product-variant-text"
      >
        <StrikeThroughLine
          v-if="isOptionNotAvailable"
          class="absolute inset-0 h-full w-full text-beige"
        />
      </span>
    </span>
  </button>
</template>
